import { AuthService } from "./services/auth.service";
import { KpiNewComponent } from "./components/kpinew/kpinew.component";
import { NgModule, ErrorHandler } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import {
  ReactiveFormsModule,
  FormsModule,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from "@angular/forms";
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
//import { HttpModule } from "@angular/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgbModule, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  HashLocationStrategy,
  Location,
  LocationStrategy,
} from "@angular/common";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { NgChartsModule } from 'ng2-charts';
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { DataTablesModule } from "angular-datatables";
import { AppRoutingModule } from "./app-routing.module";
import { PkgFilter } from "./pipes/input.filter";
// import { FilterPipe } from './pipes/filter.pipe';
import { OrderByPipe } from "./pipes/orderBy.pipe";
import { dateFormatPipe } from "./pipes/dateFormatPipe";
import { DpDatePickerModule } from "ng2-date-picker";

import { AppComponent } from "./app.component";
import { LoginComponent } from "./components/login/login.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { HeaderComponent } from "./components/header/header.component";
import { NewPartsComponent } from "./components/new-parts/new-parts.component";
import { PartInfoComponent } from "./components/part-info/part-info.component";
import { SupplyInfoComponent } from "./components/supply-info/supply-info.component";
import { PackageInfoComponent } from "./components/package-info/package-info.component";
import { PartDetailsComponent } from "./components/part-details/part-details.component";
import { GlobalPartInfoComponent } from "./components/global-part-info/global-part-info.component";
import { NewPackageComponent } from "./components/new-package/new-package.component";
import { TodoComponent } from "./components/todo/todo.component";
import { PackageComponent } from "./components/package/package.component";
import { ErrorsComponent } from "./errors.component";
import { PackageDashboardComponent } from "./components/package-dashboard/package-dashboard.component";

import { GlobalconfigService } from "./common/globalConfig.service";
import { logbaseService } from "./services/logbase.service";
import { dataService } from "./services/data.service";
import { formService } from "./services/form.service";
import { ModalService } from "./common/modal/modal.component";
import { formsEditGuardService } from "./services/formsEditGuard";
import { formDialogService } from "./services/formDialogService";
// import { TrimValueAccessorModule } from "ng-trim-value-accessor";

import { ToastrModule } from "ngx-toastr";
import { PartStatusComponent } from "./components/part-status/part-status.component";
import { ModalComponent } from "./common/modal/modal.component";
import { AuthguardGuard } from "./services/authguard.guard";
import { LoginGuard } from "./Guards/loginGuard";
import { AuthenticationService } from "./services/authentication.service";
//import { NgxPermissionsModule } from "ngx-permissions";
import { NotificationComponent } from "./components/notification/notification.component";
import { NewPackageService } from "./services/NewPackage.service";
import { AlertService } from "./services/alert.service";
import { RegistrationComponent } from "./components/registration/registration.component";
// import { AngularMultiSelectModule } from "angular2-multiselect-dropdown";
import { KpiComponent } from "./components/kpi/kpi.component";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
//import { Ng2SmartTableModule } from 'ng2-smart-table';
import { TooltipModule } from "primeng/tooltip";
import { KeyFilterModule } from "primeng/keyfilter";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { RadioButtonModule } from "primeng/radiobutton";
import { DropdownModule } from "primeng/dropdown";
import { NgxSpinnerModule } from "ngx-spinner";

// Import angular2-fusioncharts
// import { FusionChartsModule } from 'angular2-fusioncharts';
//import { ChartsModule } from "ng2-charts";
import { ChartModule as ChartModulePrime } from "primeng/chart";
//import { Ng2TableModule } from "ng2-table/ng2-table";
import { PaginationModule } from "ngx-bootstrap/pagination";
import {ModalModule} from "ngx-bootstrap/modal"
//import { AngularFontAwesomeModule } from "angular-font-awesome";

import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";

import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive"; // this includes the core NgIdleModule but includes keepalive providers for easy wireup

//import { MomentModule } from "angular2-moment"; // optional, provides moment-style pipes for date formatting
// Import FusionCharts library
// import * as FusionCharts from 'fusioncharts';
// // Import FusionCharts Charts module
// import * as Charts from 'fusioncharts/fusioncharts.charts';

import { UsermanagementComponent } from "./components/usermanagement/usermanagement.component";
import { UserActivationComponent } from "./components/user-activation/user-activation.component";
import { PackageRevisionComponent } from "./components/package-revision/package-revision.component";
// import { ChartModule } from "angular2-highcharts";
//import { LoadingPageModule } from "angular-loading-page";
//import { MaterialBarModule } from "angular-loading-page";
import { FileUploadModule } from "primeng/fileupload";
import { CalendarModule } from "primeng/calendar";
import { MultiSelectModule } from "primeng/multiselect";
import { JapanDatePipe } from "../app/pipes/japanDate.pipe";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { EqualValidator } from "./directives/equal-validator.directive";
import { ForgotPasswordComponent } from "./components/forgot-password/forgot-password.component";
import { ForgotUsernameComponent } from "./components/forgot-username/forgot-username.component";
import { SupplierCodeComponent } from "./components/supplier-code/supplier-code.component";
import { SupplierManagementComponent } from "./components/supplier-management/supplier-management.component";
import { DeliveryPointComponent } from "./components/delivery-point/delivery-point.component";
import { VendorSchedulerComponent } from "./components/vendor-scheduler/vendor-scheduler.component";
import { LineNumberComponent } from "./components/line-number/line-number.component";
import { FilterPipe } from "./pipes/filter.pipe";
import { SupplierDatabaseComponent } from "./components/supplier-database/supplier-database.component";
import { SupplierDatabaseAddressComponent } from "./components/supplier-database-address/supplier-database-address.component";
import { SupplyProcessCodeComponent } from "./components/supply-process-code/supply-process-code.component";
import { PoLedgerComponent } from "./components/po-ledger/po-ledger.component";
import { PoLedgerTotalComponent } from "./components/po-ledger-total/po-ledger-total.component";
import { PoLedgerSubTotalComponent } from "./components/po-ledger-sub-total/po-ledger-sub-total.component";
import { PoLedgerDailyComponent } from "./components/po-ledger-daily/po-ledger-daily.component";
import { L4kpiComponent } from "./components/l4kpi/l4kpi.component";
import { GroupNumberComponent } from "./components/group-number/group-number.component";
import { UppercaseDirective } from "./directives/uppercase.directive";
import { MoviewSupplierComponent } from "./components/moview-supplier/moview-supplier.component";
import { WeeklyViewComponent } from "./components/weekly-view/weekly-view.component";
import { PoFcdailyComponent } from "./components/po-fcdaily/po-fcdaily.component";
import { TableModule } from "primeng/table";
import { MaintainenceComponent } from "./components/maintainence/maintainence.component";
import { SelectDropDownModule } from 'ngx-select-dropdown';
// import { HighchartsStatic } from "angular2-highcharts/dist/HighchartsService";
import { PoFcmonthlyComponent } from "./components/po-fcmonthly/po-fcmonthly.component";
import { PoFcjunComponent } from "./components/po-fcjun/po-fcjun.component";
import { PoDashboardComponent } from "./components/po-dashboard/po-dashboard.component";
import { RoleGuardService } from "./services/role-guard.service";
import { PoSummaryComponent } from "./components/po-summary/po-summary.component";
import { PoExportsComponent } from "./components/po-exports/po-exports.component";
import { JwtInterceptor } from "./services/http-interceptors";
import { AuthErrorHandler } from "./services/authErrorHandler";
import { RestrictAccessComponent } from "./components/restrict-access/restrict-access.component";
import { SpcConfigComponent } from "./components/spc-config/spc-config.component";
import { DownloadComponent } from "./download/download.component";

import { UploadComponent } from "./components/upload/upload.component";
import { PackageuploadComponent } from "./components/packageupload/packageupload.component";
import { KkuploadComponent } from "./components/kkupload/kkupload.component";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { PartsUploadComponent } from "./components/parts-upload/parts-upload.component";
import { RackUploadComponent } from "./components/rack-upload/rack-upload.component";
import { NoubaUploadComponent } from "./components/nouba-upload/nouba-upload.component";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatChipsModule } from "@angular/material/chips";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { ModalOverviewComponent } from "./common/modal-overview/modal-overview.component";
import { MatDialogModule } from "@angular/material/dialog";
import { PfepService } from "./services/pfepService";
import { PfepHistoryComponent } from "./common/pfep-history/pfep-history.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { AddRackNoubaPopupComponent } from "./common/add-rack-nouba-popup/add-rack-nouba-popup.component";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { ConfigurationComponent } from "./components/configuration/configuration.component";
import { AddConfigComponent } from "./components/add-config/add-config.component";
import { PrefecturesComponent } from "./components/prefectures/prefectures.component";
import { PrefecturesPopupComponent } from "./common/prefectures-popup/prefectures-popup.component";
import { ServiceproviderComponent } from './components/serviceprovider/serviceprovider.component';
import { AddserviceproviderComponent } from './components/addserviceprovider/addserviceprovider.component';
import {MatRadioModule} from '@angular/material/radio';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';

// import { JwtModule, JWT_OPTIONS } from "angular2-jwt";
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

declare var require: any;

// export function highchartsFactory() {
//   const hc = require("highcharts");
//   const dd = require("highcharts/modules/drilldown");
//   dd(hc);

//   return hc;
// }

@NgModule({
  declarations: [
    MaintainenceComponent,
    AppComponent,
    LoginComponent,
    DashboardComponent,
    PageNotFoundComponent,
    HeaderComponent,
    EqualValidator,
    NewPartsComponent,
    PartInfoComponent,
    SupplyInfoComponent,
    PackageInfoComponent,
    PartDetailsComponent,
    GlobalPartInfoComponent,
    NewPackageComponent,
    TodoComponent,
    PackageComponent,
    PkgFilter,
    FilterPipe,
    OrderByPipe,
    dateFormatPipe,
    ErrorsComponent,
    PackageDashboardComponent,
    PartStatusComponent,
    ModalComponent,
    NotificationComponent,
    RegistrationComponent,
    KpiComponent,
    UsermanagementComponent,
    UserActivationComponent,
    PackageRevisionComponent,
    JapanDatePipe,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    ForgotUsernameComponent,
    SupplierCodeComponent,
    SupplierManagementComponent,
    DeliveryPointComponent,
    VendorSchedulerComponent,
    LineNumberComponent,
    SupplierDatabaseComponent,
    SupplyProcessCodeComponent,
    SupplierDatabaseAddressComponent,
    PoLedgerComponent,
    PoLedgerTotalComponent,
    PoLedgerSubTotalComponent,
    PoLedgerDailyComponent,
    L4kpiComponent,
    GroupNumberComponent,
    UppercaseDirective,
    MoviewSupplierComponent,
    WeeklyViewComponent,
    PoFcdailyComponent,
    MaintainenceComponent,
    KpiNewComponent,
    PoFcmonthlyComponent,
    PoFcjunComponent,
    PoDashboardComponent,
    PoSummaryComponent,
    PoExportsComponent,
    RestrictAccessComponent,
    SpcConfigComponent,
    DownloadComponent,
    UploadComponent,
    PackageuploadComponent,
    KkuploadComponent,
    PartsUploadComponent,
    RackUploadComponent,
    NoubaUploadComponent,
    ModalOverviewComponent,
    PfepHistoryComponent,
    AddRackNoubaPopupComponent,
    ConfigurationComponent,
    AddConfigComponent,
    ServiceproviderComponent,
    AddserviceproviderComponent,
    PrefecturesComponent,
    PrefecturesPopupComponent

  ],
  exports:[
    TableModule,
    FileUploadModule,
    MultiSelectModule

  ],

  imports: [
    NgChartsModule,
    DataTablesModule,
    // AngularMultiSelectModule,
    FontAwesomeModule,
    TableModule,
    BrowserModule,
    //Ng2SmartTableModule,
    MatAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
   // HttpModule,
    ChartModulePrime,
   // ChartsModule,
    BrowserAnimationsModule,
   // AngularMultiSelectModule,
    DialogModule,
    ButtonModule,
    KeyFilterModule,
    TooltipModule,
    DataTablesModule,
    RadioButtonModule,
    NgxSpinnerModule,
    DropdownModule,
    ProgressSpinnerModule,
    NgbModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxMaterialTimepickerModule,
    ToastrModule.forRoot({
      timeOut: 4000,
      positionClass: "toast-top-full-width",
      preventDuplicates: true,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    //NgxPermissionsModule.forRoot(),
    // ChartModule,
    // ChartModule.forRoot(require('highcharts')),
    // TrimValueAccessorModule,
   // LoadingPageModule,
   // MaterialBarModule,
    FileUploadModule,
    CalendarModule,
    MultiSelectModule,
   // Ng2TableModule,
    PaginationModule.forRoot(),
    DpDatePickerModule,
    TableModule,
    SelectDropDownModule,
    //AngularFontAwesomeModule,
    SweetAlert2Module.forRoot(),
    //MomentModule,
    NgIdleKeepaliveModule.forRoot(),
    ModalModule.forRoot(),
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatSnackBarModule,
    MatSelectModule,
    MatFormFieldModule,
    MatChipsModule,
    SelectDropDownModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatRadioModule,
    MatProgressSpinnerModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    // {
    //   provide: ErrorHandler,
    //   useClass: AuthErrorHandler
    // },
    GlobalconfigService,
    logbaseService,
    dataService,
    formService,
    formsEditGuardService,
    formDialogService,
    AlertService,
    ModalService,
    AuthguardGuard,
    LoginGuard,
    AuthenticationService,
    NewPackageService,
    NgbActiveModal,
    RoleGuardService,
    AuthService,
    PfepService,
    Location,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

// export function tokenGetter() {
//   return;
// }
